import React from "react";
import PropTypes from "prop-types";
import { browserHistory } from "react-router";
import Dialog from "rc-dialog";
import "rc-dialog/assets/bootstrap.css";
import moment from "moment";
import axios from "axios";
import loadImage from "blueimp-load-image";
import getDeep from "../components/Utils";

moment.locale("nl");

class StudentPresentAdd extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dialogOpen: false,
      errorMessage: false
    };

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
    this.handleAddStudent = this.handleAddStudent.bind(this);
  }

  handleImageDelete() {
    this.setState({
      imagePreview: null
    });
  }

  handleAddStudent() {
    this.setState({
      dialogOpen: true
    });
  }

  handleFormSubmit(e) {
    e.preventDefault();

    let addStudent = {
      event_role: this.refs.role.value,
      person: {
        initials: this.refs.initials.value,
        first_name: this.refs.first_name.value,
        last_name_prefix: this.refs.last_name_prefix.value,
        last_name: this.refs.last_name.value,
        date_of_birth: this.refs.date_of_birth_year.value + "-" + this.refs.date_of_birth_month.value + "-" + this.refs.date_of_birth_day.value,
        pro_crm_candidate_id: this.refs.pro_crm_candidate_id.value
      }
    };

    if (this.state.imagePreview === null || (typeof this.state.imagePreview === "string" && this.state.imagePreview.length > 255)) {
      // This is a file upload in base64
      addStudent.person.profile_image = this.state.imagePreview;
    }

    axios
      .post("/v1/events/" + this.props.params.eventId + "/students/", addStudent)
      .then((response) => {
        if (response.data) {
          this.props.fetchEvents();
          this.handleDialogClose();
        }
      })
      .catch((err) => {
        if (err.response.data !== undefined && err.response.data.person !== undefined) {
          this.setState({
            errorMessage: "Niet alle vereiste velden zijn juist ingevoerd, of er ging iets fout tijdens het verzenden naar de server."
          });
        } else {
          this.setState({
            errorMessage: err.response.data[0]
          });
        }
        console.warn("API Error: Adding student did not succeed", err);
      });
  }

  handleDialogClose() {
    this.setState({
      dialogOpen: false
    });
  }

  render() {
    let i = 1;
    let date_days = [];
    while (i <= 31) {
      date_days.push(
        <option value={i} key={i}>
          {i}
        </option>
      );
      i++;
    }

    i = 1;
    let date_months = [];
    while (i <= 12) {
      date_months.push(
        <option value={i} key={i}>
          {moment.months()[i - 1]}
        </option>
      );
      i++;
    }

    i = 2017;
    let date_years = [];
    while (i >= 1900) {
      date_years.push(
        <option value={i} key={i}>
          {i}
        </option>
      );
      i--;
    }

    let roles = [];
    if (this.props.roles !== undefined) {
      this.props.roles.forEach((role) => {
        if (role.role !== null && role.role !== undefined) {
          roles.push(
            <option value={role.uuid} key={role.uuid}>
              {role.role.name}
            </option>
          );
        }
      });
    }

    let errorMessage = "";
    if (this.state.errorMessage) {
      errorMessage = <div className="alert alert-warning">{this.state.errorMessage}</div>;
    }

    return (
      <div className="student-present" onClick={this.handleAddStudent}>
        <div className="profile-picture">
          <i className="fa fa-plus" aria-hidden="true"></i>
        </div>
        <div className="student-name">Cursist toevoegen</div>

        <Dialog
          title="Toevoegen van een cursist"
          onClose={this.handleDialogClose}
          animation="fade"
          visible={this.state.dialogOpen}
          footer={[
            <button type="button" className="btn btn-secondary" key="close" onClick={this.handleDialogClose}>
              Annuleren
            </button>,
            <button type="button" className="btn btn-primary" key="save" onClick={this.handleFormSubmit}>
              Opslaan
            </button>
          ]}
        >
          <div className="form form-student">
            <form onSubmit={this.handleFormSubmit}>
              <div className="date-selector">
                <label>Geboortedatum van de cursist</label>
                <select className="form-control date-day" ref="date_of_birth_day">
                  {date_days}
                </select>
                <select className="form-control date-month" ref="date_of_birth_month">
                  {date_months}
                </select>
                <select className="form-control date-year" ref="date_of_birth_year">
                  {date_years}
                </select>
              </div>

              <div className="form-group">
                <label className="sr-only">NIBHV nummer</label>
                <input type="text" name="nibhv_number" ref="pro_crm_candidate_id" className="form-control" placeholder="NIBHV nummer" />
              </div>

              <div className="form-group">
                <label className="sr-only">Roepnaam</label>
                <input type="text" name="first_name" ref="first_name" className="form-control" placeholder="Roepnaam" required />
              </div>

              <div className="form-group">
                <label className="sr-only">Tussenvoegsel</label>
                <input type="text" name="last_name_prefix" ref="last_name_prefix" className="form-control" placeholder="Tussenvoegsel" />
              </div>

              <div className="form-group">
                <label className="sr-only">Achternaam</label>
                <input type="text" name="last_name" ref="last_name" className="form-control" placeholder="Achternaam" required />
              </div>

              <div className="form-group">
                <select name="role" className="form-control" required ref="role">
                  {roles}
                </select>
              </div>

              {errorMessage}
            </form>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default StudentPresentAdd;



// WEBPACK FOOTER //
// ./components/StudentPresentAdd.js